import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Typography,
} from "@mui/material";
import AddSafety from "./AddSafety";
import EditSafety from "./EditSafety";

function Safety() {
    const [open, setOpen] = useState(false);

    const [isAddSafety, setIsAddSafety] = useState(false);
    const [isEditSafety, setIsEditSafety] = useState(false);
    const [rowData, setRowData] = useState(false);

    const handleAddSafety = () => {

        setIsAddSafety(!isAddSafety);
    }

    const handleEditSafety = (row) => {
        setIsEditSafety((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    return (

        <Box sx={{ display: "flex", flexGrow: 1, p: 3, flexDirection: "column", gap: 2 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Safety Module
            </Typography>

            <Button
                variant="contained"
                sx={{
                    backgroundColor: "#1E88E5",
                    borderRadius: 2,
                    alignSelf: "flex-start",
                    "&:hover": { backgroundColor: "#1565C0" },
                }}
                onClick={handleAddSafety}
            >
                Add New Safety
            </Button>

            <Button
                variant="contained"
                sx={{
                    backgroundColor: "#1E88E5",
                    borderRadius: 2,
                    alignSelf: "flex-start",
                    "&:hover": { backgroundColor: "#1565C0" },
                }}
                onClick={handleEditSafety}
            >
                Edit Safety
            </Button>

            {isAddSafety &&
                <AddSafety open={isAddSafety} handleClose={handleAddSafety} />
            }

            {isEditSafety &&
                <EditSafety open={isEditSafety} handleClose={handleEditSafety} rowData={rowData}/>
            }
        </Box>
    );
}

export default Safety;